export default __webpack_public_path__ + "static/clayoquot.2d6cab9f59415774b2306ded59476599.png";